module.exports = __webpack_public_path__ + "img/vocal.a9ffe198.png";